import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../models/user.model';

/**
 * Guard que redirige a los usuarios autenticados a su panel correspondiente
 * según su rol cuando intentan acceder a la raíz (/).
 */
export const homeRedirectGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Si el usuario está logueado, redirigir según su rol
  if (authService.isLoggedIn()) {
    const user = authService.currentUser();

    if (!user) {
      return true;
    }

    switch (user.role) {
      case UserRole.SuperAdmin:
        router.navigate(['/superadmin/dashboard']);
        return false;
      case UserRole.Owner:
      case UserRole.Manager:
        router.navigate(['/owner/categories']);
        return false;
      case UserRole.Contador:
        router.navigate(['/owner/finanzas']);
        return false;
      case UserRole.Waiter:
        router.navigate(['/waiter/orders']);
        return false;
      case UserRole.Kitchen:
        router.navigate(['/kitchen/orders']);
        return false;
      case UserRole.Cashier:
        router.navigate(['/cashier/orders']);
        return false;
      case UserRole.Delivery:
        router.navigate(['/delivery/orders']);
        return false;
      default:
        return true;
    }
  }

  // Si no está logueado, permitir continuar (irá a login)
  return true;
};
